module.exports = __webpack_public_path__ + "static/Footer-a825f6ac564f87467b4023fa24a8ed0b.png";